import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';

const routerBasename = import.meta.env.BASE_URL.replace(/\/$/, '') || '/';
import { AuthProvider } from './contexts/AuthContext';
import { DocumentProvider } from './contexts/DocumentContext';
import { ChatProvider } from './contexts/ChatContext';
import Landing from './pages/Landing';
import Login from './pages/Login';
import Register from './pages/Register';
import Dashboard from './pages/Dashboard';
import Profile from './pages/Profile';
import AppMain from './pages/AppMain';
import ProtectedRoute from './components/shared/ProtectedRoute';

function App() {
  return (
    <Router basename={routerBasename}>
      <AuthProvider>
        <DocumentProvider>
          <ChatProvider>
            <Routes>
              <Route path="/" element={<Landing />} />
              <Route path="/login" element={<Login />} />
              <Route path="/register" element={<Register />} />
              <Route
                path="/dashboard"
                element={
                  <ProtectedRoute>
                    <Dashboard />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/profile"
                element={
                  <ProtectedRoute>
                    <Profile />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/app"
                element={
                  <ProtectedRoute>
                    <AppMain />
                  </ProtectedRoute>
                }
              />
            </Routes>
          </ChatProvider>
        </DocumentProvider>
      </AuthProvider>
    </Router>
  );
}

export default App;